export const getVersion = (): string => {
    return import.meta.env.VITE_APP_VERSION || '0.0.0';
};
